export default __webpack_public_path__ + "static/media/basic-pin-large-12.d24a3926.png";